import React  from "react";

export  const PageNotFound = ()=>{


  return(

      <div className="container">

         <p className="text-center p-4 fs-3"><span className="fw-bolder fs-1"> 404 </span> Page note found</p>
         <p className="text-center p-3 fs-3">Please try checking your url if it is typed  correctly</p>


      </div>
  )
 

}